/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ItemTypeConstants = {
    Base: 'Base',
    Collection: 'Collection',
    MultiUnitValues: 'MultiUnitValues',
    Reference: 'Reference'
} as const;
export type ItemTypeConstants = typeof ItemTypeConstants[keyof typeof ItemTypeConstants];


export function ItemTypeConstantsFromJSON(json: any): ItemTypeConstants {
    return ItemTypeConstantsFromJSONTyped(json, false);
}

export function ItemTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ItemTypeConstants {
    return json as ItemTypeConstants;
}

export function ItemTypeConstantsToJSON(value?: ItemTypeConstants | null): any {
    return value as any;
}

